import "@/App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ScopeGrid from "@/pages/ScopeGrid";
import ReportView from "@/pages/ReportView";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<ScopeGrid />} />
          <Route path="/report/:caseId" element={<ReportView />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
